import { useState, useCallback, useMemo } from 'react'
import { debounce } from 'lodash'
import { TransactionOrSplit } from '@/reducers/admin/allTransactions.slice'
import {
  dollarsToCents,
  formatCurrencyFromCents,
} from '@/utils/currencyHelpers'
import { useAppDispatch } from '@/utils/typeHelpers'
import { updateUserTransaction } from '../transactions.slice'

import { Input } from '@/ui'

interface TransactionAmountInputProps {
  transaction: TransactionOrSplit
  disabled?: boolean
}

export const TransactionAmountInput = ({
  transaction,
  disabled,
}: TransactionAmountInputProps) => {
  const [value, setValue] = useState(transaction.amountInCents)
  const dispatch = useAppDispatch()

  const debouncedUpdateTransaction = useMemo(
    () =>
      debounce((newValue: number | undefined) => {
        if (transaction.amountInCents === (newValue || 0)) return

        updateUserTransaction(transaction.id, { amountInCents: newValue })(
          dispatch
        )
      }, 1000),
    [transaction.amountInCents, transaction.id, dispatch]
  )

  const handleChange = useCallback(
    (newValue: number | undefined) => {
      setValue(newValue ? newValue : 0)
      debouncedUpdateTransaction(newValue)
    },
    [debouncedUpdateTransaction]
  )
  return (
    <Input
      value={formatCurrencyFromCents(value).toString() ?? ''}
      type="text"
      disabled={disabled}
      onChange={(e) => handleChange(dollarsToCents(e.target.value))}
    />
  )
}
